module.exports = __webpack_public_path__ + "static/cartoon-edadac3c1f0f72c582c83a783c2e05b4.png";